import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.6553 10.4053C18.9482 10.1124 18.9482 9.63756 18.6553 9.34467L12.4053 3.09467C12.1124 2.80178 11.6376 2.80178 11.3447 3.09467L5.09467 9.34467C4.80178 9.63756 4.80178 10.1124 5.09467 10.4053C5.38756 10.6982 5.86244 10.6982 6.15533 10.4053L11.125 5.43566L11.125 19.875C11.125 20.2892 11.4608 20.625 11.875 20.625C12.2892 20.625 12.625 20.2892 12.625 19.875L12.625 5.43566L17.5947 10.4053C17.8876 10.6982 18.3624 10.6982 18.6553 10.4053Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowUp;
